export const canMultiSelect = (flowPermissions, flow) =>
    flow && (flowPermissions.canDelete || !flow.IsLocked || flowPermissions.canCalculate);
